import React, { useContext, useEffect, useState } from "react";
import { WidgetContext } from "../../contexts/widgetContext";

import {
  Container,
  ContentContainer,
  HeaderConfiguration,
  InputContainer,
  KeyboardContainer,
  Key,
  ActionsGroupButtons,
  Button,
} from "./styles";
import { FiArrowLeftCircle } from "react-icons/fi";
import { MdCall } from "react-icons/md";
import { RouterContext } from "../../contexts/routerContext";
import Header from "../../components/v2/layout/header";

const MakeACallScreen = ({ handleExecCall }) => {
  const { setRouter, routerParams, setRouterParams } =
    useContext(RouterContext);
  const { interationSIP, callInProgress } = useContext(WidgetContext);

  const [phone, setPhone] = useState("");
  const keys = [1, 2, 3, 4, 5, 6, 7, 8, 9, "*", "0", "#"];

  useEffect(() => {
    if (routerParams) {
      if (routerParams.channelType === "CALL") {
        if (routerParams.client.contact_number) {
          setPhone(routerParams.client.contact_number);
        }
      }
    }
  }, [routerParams]);

  const handlePressKey = (key) => {
    setPhone(phone + key);
    if (callInProgress.status === "Progress") {
      interationSIP.keyPadPress(key);
    }
  };

  const handleAddKey = (key) => {
    setPhone(key.replace(/[^0-9]/g, "").replace(/ /g, ""));
  };

  const pressEnter = (event) => {
    if (
      event.key === "Enter" &&
      callInProgress.status === "Progress" &&
      phone.length > 0
    ) {
      handleTransferCall();
    }
    if (event.key === "Enter" && phone.length > 0) {
      handleExecCall(phone);
      setRouterParams(undefined);
    }
  };

  const handleMakeCall = () => {
    const lastPhone = localStorage.getItem("BC_lastPhoneNumber");

    if (lastPhone && !phone) {
      setPhone(lastPhone);
      return;
    }

    if (phone) {
      localStorage.setItem("BC_lastPhoneNumber", phone);
      handleExecCall(phone);
      setRouterParams(undefined);
    } else {
      alert("Informe um número para contato.");
    }
  };

  const handleTransferCall = () => {
    interationSIP.transfer(phone).then(() => {
      setRouter("home");
    });
  };
  return (
    <Container>
      <Header buttonBackAction={() => setRouter("home")}>
        <HeaderConfiguration>
          <span>Telefone</span>
        </HeaderConfiguration>
      </Header>
      <InputContainer>
        <input
          placeholder="Insira o número"
          value={phone}
          autoFocus
          onChange={(e) => handleAddKey(e.target.value)}
          onKeyDown={pressEnter}
          maxLength={20}
        />
        {/*{phone?.length > 0 ? (*/}
        {/*  <button*/}
        {/*    onClick={() => setPhone(phone.substring(0, phone.length - 1))}*/}
        {/*  >*/}
        {/*    <FiArrowLeftCircle size={24} color="#ff0000" />*/}
        {/*  </button>*/}
        {/*) : (*/}
        {/*  <span onClick={() => setRouter("home")}>Ver Histórico</span>*/}
        {/*)}*/}
      </InputContainer>
      <ContentContainer>
        <KeyboardContainer>
          {keys.map((value) => (
            <Key key={value} onClick={() => handlePressKey(value)}>
              {value}
            </Key>
          ))}
        </KeyboardContainer>
        <ActionsGroupButtons>
          {callInProgress.status === "Progress" ? (
            <Button onClick={() => handleTransferCall()}>
              <MdCall size={16} />
              <span>Transferir</span>
            </Button>
          ) : (
            <Button onClick={handleMakeCall}>
              <MdCall size={16} />
              <span>Ligar</span>
            </Button>
          )}
        </ActionsGroupButtons>
      </ContentContainer>
    </Container>
  );
};

export default MakeACallScreen;
